/* eslint-disable func-names */
/* eslint-disable no-undef */
const stickyBar = () => {
  (function ($) {
    const d = document;
    const w = window;
    const b = d.body;
    const $window = $(window);
    const $footer = $(".c-footer");
    const $footerBottom = $(".c-footer-bottom");
    const $stickybar = $(".c-sticky-bar");
    const $stickybarPanel = $(".c-sticky-bar__inner");
    const $getInTouch = $(".js-get-in-touch");
    const $getInTouchElem = $(".c-get-in-touch");
    const $chevron = $(".c-sticky-bar__chevron");
    const $list = $(".c-sticky-bar__list");
    const $chat = $(".c-sticky-bar__cta--chat");
    const chatVisible = "c-sticky-bar__cta--chat--visible";
    const listVisible = "c-sticky-bar__list--visible";
    const isSticky = "c-sticky-bar--sticky";
    const stickybarPanelOpen = "c-sticky-bar__inner--open";
    const chevronOpen = "c-sticky-bar__chevron--open";
    const stickybarHide = "c-sticky-bar--hide";

    // is in Viewport
    const isInViewport = (el) => {
      const rect = el[0].getBoundingClientRect();
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const windowWidth =
        window.innerWidth || document.documentElement.clientWidth;
      const vertInView =
        rect.top <= windowHeight && rect.top + rect.height >= 0;
      const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;

      return vertInView && horInView;
    };

    $window.on("scroll", () => {
      const scrollBottom = b.scrollHeight - w.innerHeight - w.pageYOffset;
      const isGetInTouchVisible = isInViewport($getInTouchElem);

      if (
        scrollBottom <=
        $footer[0].scrollHeight + $footerBottom[0].scrollHeight
      ) {
        $stickybar.removeClass(isSticky);
        return;
      }

      $stickybar.addClass(isSticky);

      if (isGetInTouchVisible) {
        $stickybar.addClass(stickybarHide);
        $stickybarPanel.removeClass(stickybarPanelOpen);
        $chevron.removeClass(chevronOpen);
        $list.removeClass(listVisible);
        $chat.removeClass(chatVisible);
      } else {
        $stickybar.removeClass(stickybarHide);
      }
    });

    $getInTouch.on("click", (e) => {
      e.preventDefault();
      $stickybarPanel.toggleClass(stickybarPanelOpen);
      $chevron.toggleClass(chevronOpen);
      $list.toggleClass(listVisible);
      $chat.toggleClass(chatVisible);
    });
  })(jQuery);
};

export default stickyBar;
